/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokenResponseModel } from '../../models/token-response-model';
import { UserLogin } from '../../models/user-login';

export interface AuthenticationLogin$Params {
      body?: UserLogin
}

export function authenticationLogin(http: HttpClient, rootUrl: string, params?: AuthenticationLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenResponseModel>> {
  const rb = new RequestBuilder(rootUrl, authenticationLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenResponseModel>;
    })
  );
}

authenticationLogin.PATH = '/v1/Authentication/Login';
